<template>
  <div>
    <fixnav></fixnav>
    <banner use="join" class="joinBanner" :isMobile="isMobile">
      <div class="egoBtn" slot="info-content">
        <a @click="clickBtn" href="/apply">
          <ego-button :use="isMobile?'mobile':''">申请加入</ego-button>
        </a>
      </div>
    </banner>
    <join-condition :isMobile="isMobile"></join-condition>
    <join-line :isMobile="isMobile"></join-line>
    <join-right :isMobile="isMobile"></join-right>
  </div>
</template>
<script>
import banner from '@/components/banner'
import egoButton from '@/base/ego-button-new'
import joinCondition from './join-condition'
import joinLine from './join-line'
import joinRight from './join-right'
import { mapState } from 'vuex'
import fixnav from '@/components/fixnav'
import weixinshare from '@/util/weixinshare'

export default {
  data () {
    return {}
  },
  components: {
    banner,
    joinCondition,
    joinLine,
    joinRight,
    egoButton,
    fixnav
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  created () {
    window.document.title = '申请加入 | TGO'
  },
  mounted () {
    weixinshare({
      title: 'TGO 鲲鹏会 | 学员申请表',
      desc: '加入 TGO 鲲鹏会，与近千位科技领导者一起交流学习'
    })
  },
  methods: {
    clickBtn () { if (window.ga) window.ga('send', 'event', '页面点击', '招募页-现在报名') }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

::v-deep .ego-button {
  margin: 25vw auto 0;
  width: 200px;
  @include mobile {
    margin-top: 70vw;
  }
}

</style>
